// The support overview's page-level user search: type a name, email, or user id and pick a user to view.

import React from 'react'
import PropTypes from 'prop-types'

import { MeSearchCombobox } from '@CommonComponents'
import { client } from '@Utils'

export const UserOption = ({ user, current }) => (
  <>
    <span className="me-search-option-main">
      <span className="me-search-option-title">{user.name || user.email}</span>
      <span className="me-search-option-detail">
        {[user.name ? user.email : '', user.institution]
          .filter(Boolean)
          .join(' · ')}
      </span>
    </span>
    {current && (
      <span className="me-badge-tint me-badge-tint-brand">Viewing</span>
    )}
  </>
)

UserOption.propTypes = {
  user: PropTypes.object.isRequired,
  current: PropTypes.bool,
}

export const UserSearch = ({
  searchUrl,
  currentUserId,
  autoFocus,
  navigate = url => window.location.assign(url),
}) => (
  <MeSearchCombobox
    label="Find a user"
    placeholder="Find a user by name, email, or ID"
    large
    autoFocus={autoFocus}
    search={(q, { signal }) =>
      client
        .get(searchUrl, { params: { q }, signal })
        .then(response => response.data)
    }
    optionKey={user => user.id}
    renderOption={user => (
      <UserOption user={user} current={user.id === currentUserId} />
    )}
    onSelect={user => navigate(user.url)}
    noResultsText="No users match"
  />
)

UserSearch.propTypes = {
  searchUrl: PropTypes.string.isRequired,
  currentUserId: PropTypes.string,
  autoFocus: PropTypes.bool,
  navigate: PropTypes.func,
}
